export default __webpack_public_path__ + "static/media/Logo.d79ce096.png";